import React from 'react'
import homeStyles from './home.module.scss';

import { Container, Row, Col } from "reactstrap";
import Button from "../../elements/layout";

const HomeSection = () => (
  <div id="home" className={`section ${homeStyles.noPadding}`}>
    <div id={homeStyles.background}>
      <Container>
        <Row>
          <Col xs="12" md="6" className={homeStyles.headingWrapper}>
            <h1>
              GridBox -<br/>prostredie na vizualizáciu mikrogridu
          </h1>
            <a href="#about-project"><Button dark>Viac o projekte</Button></a>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);

export default HomeSection